import * as types from './mutation-types'

export const loadCountStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_LOADING, true)
    const params = new URLSearchParams({
      startDate: query.startDate,
      endDate: query.endDate
    })
    if (query.shop_id) params.append('shop_id', query.shop_id)
    if (query.society_id) params.append('society_id', query.society_id)

    window.axios.get(`admin/dashboard/statistics/count?${params.toString()}`)
      .then((response) => {
        commit(types.LOAD_SHOP_COUNT_STATS, response.data)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
      .finally(() => {
        commit(types.SET_LOADING, false)
      })
  })
}

export const loadAdvancedCountStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    commit(types.SET_LOADING, true)
    const params = new URLSearchParams({
      startDate: query.startDate,
      endDate: query.endDate
    })
    if (query.shop_id) params.append('shop_id', query.shop_id)
    if (query.society_id) params.append('society_id', query.society_id)

    window.axios.get(`admin/advanced/statistics/count?${params.toString()}`)
      .then((response) => {
        commit(types.LOAD_SHOP_ADVANCED_COUNT_STATS, response.data)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
      .finally(() => {
        commit(types.SET_LOADING, false)
      })
  })
}

export const loadDataStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      startDate: query.startDate,
      endDate: query.endDate
    })
    if (query.shop_id) params.append('shop_id', query.shop_id)
    if (query.society_id) params.append('society_id', query.society_id)

    window.axios.get(`admin/dashboard/statistics/data?${params.toString()}`)
      .then((response) => {
        commit(types.LOAD_SHOP_DATA_STATS, response.data.data)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const loadCategoryStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      startDate: query.startDate,
      endDate: query.endDate
    })
    if (query.shop_id) params.append('shop_id', query.shop_id)
    if (query.society_id) params.append('society_id', query.society_id)

    window.axios.get(`admin/advanced/statistics/category?${params.toString()}`)
      .then((response) => {
        commit(types.LOAD_SHOP_CATEGORY_STATS, response.data)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const loadCustomerStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      startDate: query.startDate,
      endDate: query.endDate
    })
    if (query.shop_id) params.append('shop_id', query.shop_id)
    if (query.society_id) params.append('society_id', query.society_id)

    window.axios.get(`admin/advanced/statistics/customer?${params.toString()}`)
      .then((response) => {
        commit(types.LOAD_SHOP_CUSTOMER_STATS, response.data)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const loadSaleStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      startDate: query.startDate,
      endDate: query.endDate
    })
    if (query.shop_id) params.append('shop_id', query.shop_id)
    if (query.society_id) params.append('society_id', query.society_id)

    window.axios.get(`admin/advanced/statistics/vente?${params.toString()}`)
      .then((response) => {
        commit(types.LOAD_SHOP_SALE_STATS, response.data)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const loadBestDayStatistics = ({ commit }, query = {}) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams()
    if (query.shop_id) params.append('shop_id', query.shop_id)
    if (query.society_id) params.append('society_id', query.society_id)

    window.axios.get(`admin/dashboard/statistics/best-day?${params.toString()}`)
      .then((response) => {
        commit(types.LOAD_SHOP_BEST_DAY_STATS, response.data.data)
        resolve(response)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export const loadAllStatistics = ({ dispatch }, query) => {
  return Promise.all([
    dispatch('loadCountStatistics', query),
    dispatch('loadCategoryStatistics', query),
    dispatch('loadDataStatistics', query),
    dispatch('loadCustomerStatistics', query),
    dispatch('loadAdvancedCountStatistics', query),
    dispatch('loadSaleStatistics', query)
  ])
}

export const loadAllCategoryStatistics = ({ dispatch }, query) => {
  return Promise.all([
    dispatch('loadCountStatistics', query),
    dispatch('loadCategoryStatistics', query)
  ])
}

export const loadAllSaleStatistics = ({ dispatch }, query) => {
  return Promise.all([
    dispatch('loadCountStatistics', query),
    dispatch('loadAdvancedCountStatistics', query),
    dispatch('loadSaleStatistics', query)
  ])
}
